export const Types = {
  REQUEST: '@SVAs/REQUEST',
  SUCCESS: '@SVAs/SUCCESS',
  FAILURE: '@SVAs/FAILURE',
};

export function svaListRequest(cpf) {
  return {
    type: Types.REQUEST,
    cpf,
  };
}

export function setSVAListSuccess(data) {
  return {
    type: Types.SUCCESS,
    data,
  };
}

export function setSVAListFailure() {
  return {
    type: Types.FAILURE,
  };
}
